"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnDemandShouldDisableReport = exports.isOnDemandProgrammeToItemEdgeType = void 0;
const tslib_1 = require("tslib");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const debug_1 = require("../../../util/lambda/debug");
const debug = debug_1.DEBUG_OVERRIDE || (debug_1.NOT_LAMBDA && false);
const isOnDemandProgrammeToItemEdgeType = (x) => {
    const e = x;
    const passes = !!e && (0, iotv_v3_types_1.isEdge)(e) && !!e.edgeAttributes && (0, iotv_v3_types_1.isNonNaNNumber)(e.edgeAttributes.window);
    debug && console.log(`INFO: isOnDemandProgrammeToItemEdgeType passes ${passes}`, x);
    return passes;
};
exports.isOnDemandProgrammeToItemEdgeType = isOnDemandProgrammeToItemEdgeType;
const isOnDemandShouldDisableReport = (requestedRollingConfig, programme) => {
    if (requestedRollingConfig.startTimeUtcSeconds === 0)
        return false;
    if (programme.startTime === 0 && requestedRollingConfig.startTimeUtcSeconds !== 0)
        return true;
    const now = dayjs_1.default.utc().unix();
    const lastActiveTime = dayjs_1.default
        .utc(programme.startTime * iotv_v3_types_1.Milliseconds.SECOND)
        .add(programme.getTotalRepeatTime(), 'minutes')
        .unix();
    debug && console.log('INFO: isOnDemandShouldDisableReport', now, programme.getTotalRepeatTime(), lastActiveTime);
    return lastActiveTime <= now;
};
exports.isOnDemandShouldDisableReport = isOnDemandShouldDisableReport;
